<template>
  <div class="column" :class="columnSize">
    <base-combobox
      :value="value"
      :service="service"
      :fetch-func="fetchFunc"
      :fetch-params="fetchParams"
      :fetch-on-init="fetchOnInit"
      :allow-new="false"
      :label="label"
      :label-key="labelKey"
      :custom-formatter="customFormatter"
      small
      :horizontal="horizontal"
      :disabled="disabled"
      @select="onSelect"
      ref="baseCombobox"
    />
  </div>
</template>

<script>
import BaseCombobox from "@/components/partials/BaseCombobox";

export default {
  props: {
    service: {
      type: Function,
      required: true,
    },
    fetchFunc: {
      type: String,
      required: true,
    },
    fetchParams: {
      type: Object | String,
      default: () => {},
    },
    fetchOnInit: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    valueKey: {
      type: String,
      default: "id",
    },
    labelKey: {
      type: String,
    },
    horizontal: {
      type: Boolean,
      default: true,
    },
    columnSize: {
      type: Object | String,
      default: "is-12",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customFormatter: {
      type: Function,
    },
  },
  components: {
    BaseCombobox,
  },
  methods: {
    fetchOptions() {
      this.$refs.baseCombobox.fetchOptions();
    },
    onSelect(option) {
      const value = option ? option[this.valueKey] : "";
      this.$emit("input", value);
      this.$emit("update:value", value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldAutocomplete.vue